export enum Ethnicity {
    NONE = '',
    WHITE = 'White',
    AFRICAN_AMERICAN = 'African American',
    HISPANIC = 'Hispanic',
    ASIAN = 'Asian',
    OTHER = 'Other'
}